<template>
    <div>
        <div class="top flex-middle">
            <img src="@/assets/SeQure-white.svg" style="height: 60%;width: auto;">
        </div>

        <div class="dataPage" style="height: 85vh;;margin-top: 70px;">
            <h4 style="margin-left:15px">Image Results</h4>
            
            <div class="h-100 p-10" >
                <!-- {{ imageData }} -->
                <div v-for="image in imageData" style="height: 125px;border-bottom: 1px solid #444;">
                    <!-- {{ image }} -->
                    <div class="row h-100 pt-2">
                        <div class="col-4 col-lg-2 h-100 flex-middle" style="justify-content: center;">
                            <img :src="'data:image/png;base64,' + image.base64" style="height: 100%;width:auto;max-width: 100%;"/>
                        </div>
                        <div class="col-8 col-lg-10">
                            <h6>Image Status : {{ image.status }}</h6>
                            <h6>Qrcode : {{ image.qrcode ? image.qrcode : '-' }}</h6>
                            <h6>Label : {{ image.label ? image.label : '-' }}</h6>
                            <h6>Score : {{ image.score ? image.score : '-' }}</h6>
                        </div>
                    </div>
                    <!-- <hr> -->
                    

                </div>
                <button class="btn btn-secondary w-100" @click="$router.push('/manual')">Back To Camera</button>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    mounted () {
        this.imageData = this.$route.query.imageResult
    },
    data () {
        return {
            imageData : null
        }
    }
}
</script>

<style scoped>
    .top {
        top : 0px;
        height: 60px;
        border-bottom: 1px solid #CCC;
        position: absolute;
        width : 100%;
        background :rgba(0, 0, 0, 0.5) 0% 0% no-repeat padding-box;
    }

    .flex-middle {
        display: flex;
        /* justify-content: center; */
        align-items: center;
        padding-left: 2em;
    }

    .dataPage {
        overflow-y: scroll;
        overflow-x:hidden;
        width: 100%;
    }

</style>